let slimGridItems = null;

document.addEventListener('DOMContentLoaded', function () {
  const headerSection = document.querySelector('.Header_section');
  const mainElement = document.querySelector('.main-section');
  
  function updatePadding() {
    if (!document.querySelector('.transparent-header') && headerSection && mainElement) {
      const headerHeight = headerSection.offsetHeight;
      mainElement.style.paddingTop = `${headerHeight}px`;
    }
  }

  function updatePaddingAndTop() {
    if (!document.querySelector('.transparent-header') && headerSection) {
      const headerHeight = headerSection.offsetHeight;
      const paddingTopValue = `${headerHeight}px`;
      const topValue = `${headerHeight + 10}px`;

      // Create a <style> element
      const style = document.createElement('style');
      style.innerHTML = `
        .padding-top {
          padding-top: ${paddingTopValue};
        }
        .top-position {
          top: ${topValue}; 
        }
      `;

      // Append the <style> element to the <head> of the document
      document.head.appendChild(style);
    }
  }

  // Call the functions when the page loads
  updatePadding();
  updatePaddingAndTop();

  // Call the functions when the window is resized
  window.addEventListener('resize', updatePadding);
  window.addEventListener('resize', updatePaddingAndTop);

  // Observe changes to the size of the headerSection
  const resizeObserver = new ResizeObserver(updatePadding);
  resizeObserver.observe(headerSection);

  if (window.location.pathname === '/') {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 0) {
        document.querySelector('#header').classList.add('bg-primary-bg');
      } else {
        document.querySelector('#header').classList.remove('bg-primary-bg');
      }
    });
  }

  // Add functionality for .slim_grid_item elements
  slimGridItems = document.querySelectorAll('.slim_grid_item');
  if (slimGridItems.length > 0) {
    slimGridItems.forEach(item => {
      item.classList.add('bg-white');
    });
    window.addEventListener('scroll', function() {
      slimGridItems.forEach(item => {
        if (window.scrollY > 0) {
          item.classList.add('bg-primary-bg');
          item.classList.remove('bg-white');
        } else {
          item.classList.add('bg-white');
          item.classList.remove('bg-primary-bg');
        }
      });
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const mainSection = document.querySelector('.frontpage'); 
  if (mainSection) {

    // Apply bg-primary-bg on load only if page is not scrolled
    // Apply bg-white if page is initially scrolled
    if (window.scrollY >= 0.05) {
      mainSection.classList.remove('bg-primary-bg');
      mainSection.classList.add('bg-white');
    } else {
      mainSection.classList.add('bg-primary-bg');
    }
  
    window.addEventListener('scroll', () => {
        const scrollPosition = window.scrollY;
        const targetPositionMain = window.innerHeight * 0.05; 

        if (scrollPosition >= targetPositionMain) {
          mainSection.classList.remove('bg-primary-bg'); 
          mainSection.classList.add('bg-white');
          if (slimGridItems && slimGridItems.length > 0) {
            slimGridItems.forEach(item => {
              item.classList.remove('bg-primary-bg');
              item.classList.add('bg-white');
            });
          }
        } else {
          mainSection.classList.remove('bg-white');
          mainSection.classList.add('bg-primary-bg');
          if (slimGridItems && slimGridItems.length > 0) {
            slimGridItems.forEach(item => {
              item.classList.remove('bg-white');
              item.classList.add('bg-primary-bg');
            });
          }
        }
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const mainHeader = document.querySelector('#shopify-section-main-header');

  window.addEventListener('scroll', () => {
    const scrollPosition = window.scrollY;
    const targetPositionHeader = window.innerHeight * 0.01; 

    if (scrollPosition >= targetPositionHeader) {
      mainHeader.classList.add('header-dropshadow');
    } else {
      mainHeader.classList.remove('header-dropshadow');
    }

  });

  window.addEventListener('scroll', function() {

      const header = document.querySelector('.header-outer');
      const announcement = document.querySelector('.announcement-outer');
      const scrollPosition = window.scrollY || document.documentElement.scrollTop;
      const announcementHeight = announcement ? announcement.offsetHeight : 0;

      if (scrollPosition > 0.01) {
        header.classList.add('header-scrolled');
        header.style.transform = `translateY(-${announcementHeight}px)`;
        header.style.transition = 'all 0.4s ease';
        announcement && announcement.classList.add('announcement-hidden');
      } else {
        header.classList.remove('header-scrolled');
        header.style.transform = 'translateY(0)';
        header.style.transition = '';
        announcement && announcement.classList.remove('announcement-hidden');
      }
    
  });
});